<div *ngIf="type=='meeting'"> 
	<h3 class="title">Meeting Count</h3> 
	<!-- <mat-chip-listbox aria-span="Item selection" [(ngModel)]="selectedMeeting" [selectable]="selectedMeeting === selectedMeetingFilter ? false : true"> 
		<mat-chip-option class="chip-option" *ngFor="let chip of frameworkChips"
						selected [value]="chip.name" [color]="chip.color" (click)="periodChange($event,chip.name)"> 
			{{chip.name}} 
		</mat-chip-option> 
	</mat-chip-listbox> 

	<div>my Meeting</div>
		<mat-chip-grid #chipGrid aria-label="Enter fruits" *ngIf="formatedMeetingData?.myMeetings?.length > 0">
					<span *ngFor="let chip of formatedMeetingData.myMeetings">
						<mat-chip-row  class="chip-option" (click)="getMeetings(chip)" *ngIf="chip.MEETINGHISSTATUS != ''">
						 {{meetingStatus.get(chip.MEETINGHISSTATUS+"")}} : {{chip.MEETING_COUNT}}
						</mat-chip-row>
					</span>
					<input [matChipInputFor]="chipGrid" type="text" [ngStyle]="{'display':'none'}">
					</mat-chip-grid> -->
		<div class="container">
			<!-- <div class="filter" [ngStyle]="{'width':filterOpen() ? '150px' : '','height':(containerHeight - 51)+'px'}">
				<div class="font filter-icon adc-d-flex adc-gap-2">
					<span class="material-symbols-outlined" (click)="filterOpen.set(!filterOpen())" [ngStyle]="{'color':'#fff'}">filter_alt</span>
					<span [ngStyle]="{'color':'#fff'}" *ngIf="filterOpen()">Filter</span>
				 </div>
						@if(filterOpen()){
							<ul class="filter-dropdown">
								@for (chip of frameworkChips; track $index) {									
										<li class="adc-cursor-pointer" (click)="periodChange($event,chip.name)" [ngStyle]="{'background-color':selectedMeetingFilter === chip.name ? '#4c60cab8' : '','color':selectedMeetingFilter === chip.name ? '#fff' : ''}">{{chip.name}}</li>
								}
							</ul>
						}
						</div> -->
					<div class="filter-day">
						@for (chip of frameworkChips; track $index) {	
							<!-- <span class="adc-tag-icon-right adc-d-flex adc-align-items-center" [ngStyle]="{'background-color':selectedMeetingFilter === chip.name ? 'var(--adc-primary-theme)' : '','border':selectedMeetingFilter === chip.name ?'0.5px solid #fff' : ''}">
								<label class="adc-cursor-pointer {{selectedMeetingFilter === chip.name ? 'adc-cl-white' : ''}}" title="{{chip.name}}"  (click)="periodChange($event,chip.name)">{{chip.name}}</label>
								</span>  -->
								<button class="adc-btn adc-btn-sm adc-mr5 adc-cursor-pointer" [style.border-radius]="'unset'" [ngClass]="selectedMeetingFilter === chip.name ? 'filter-day-active' :''" (click)="periodChange($event,chip.name)">{{chip.name}}</button>
					}
					</div>

	
		<!-- <div class="adc-tab-view adc-mt10 adc-m0 adc-w-100" [ngStyle]="{'margin':0,'height':(containerHeight - 51)+'px'}" id="org1">
			<div class="adc-tab-nav adc-justify-content-between">
			  <div class="adc-d-flex">
				<div class="adc-tab-button adc-tab-bs1 font active" (click)="setActiveTab2('tab1', 'org1')" data-tab-target="tab1">
				  {{'My Meeting' | translate}}</div>
				<div class="adc-tab-button adc-tab-bs1 font"  (click)="setActiveTab2('tab2', 'org1')" data-tab-target="tab2">
				  {{"Other Meetings" | translate}}</div>
			  </div>
			</div>
		
			<div class="adc-tab-content adc-w-100">
			  <div class="adc-tab-pane overflow-auto adc-tab-ps1 active" data-tab-name="tab1">
				  <div class="meeting-card">
					@for(chip of formatedMeetingData.myMeetings;track chip){
						<div class="meeting-list" [style.background]="getBackgroundColor(meetingStatus.get(chip.MEETINGHISSTATUS+''))" (click)="getMeetings(chip)">
						 @if(chip.MEETINGHISSTATUS != ''){
							 <div>{{meetingStatus.get(chip.MEETINGHISSTATUS+"")}}</div>
							 <div class="fw-600 font-30 adc-pt15">{{chip.MEETING_COUNT}}</div>
						 }
						</div>
					 }
				  </div>
			  </div>
	
			  <div class="adc-tab-pane overflow-auto adc-tab-ps1" data-tab-name="tab2">
					<div class="meeting-card">
						@for(chip of formatedMeetingData.otherMeetings;track chip){
							<div class="meeting-list" [style.background]="getBackgroundColor(meetingStatus.get(chip.MEETINGHISSTATUS+''))" (click)="getMeetings(chip)">
							 @if(chip.MEETINGHISSTATUS != ''){
									<div>{{meetingStatus.get(chip.MEETINGHISSTATUS+"")}}</div>
									<div class="fw-600 font-30 adc-pt15">{{chip.MEETING_COUNT}}</div>
							 }
							</div>
						 }
					</div>
			  </div>
			  </div>
			  </div> -->

			<div class="meetingtypes" [ngStyle]="{'height':(containerHeight - 140)+'px'}">
				<div class="d-flex bg-primary adc-mb15">
					@for(item of meetingTypes;track item){
						<div class="meeting-item" (click)="activeMeetingTypes(item)" [style.border]="activemeeting !== item ? '0.5px solid #DFe3eb' : ''" [ngClass]="activemeeting === item ? 'meeting-active' : ''" >
						   {{item}}
						</div>
					}
					 </div>

					 @if(activemeeting === 'My Meetings'){
						<!-- [style.background]="getBackgroundColor(meetingStatus.get(chip.MEETINGHISSTATUS+''))" -->
						<div class="meeting-card">
						
						      @if(formatedMeetingData?.myMeetings?.length > 0){
								@for(chip of formatedMeetingData?.myMeetings;track chip){
									<div class="meeting-list"  (click)="getMeetings(chip)">
									 @if(chip.MEETINGHISSTATUS != ''){
										<div class="d-flex gap-2"> 
											<div>
												@if(meetingStatus.get(chip.MEETINGHISSTATUS+"") === 'Completed'){
													<!-- <span class="material-symbols-outlined" [ngStyle]="{'color':'#4caf50'}">check_circle</span> -->
													<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="8" y="12" width="48" height="40" rx="6" ry="6" stroke="#4CAF50" stroke-width="4" fill="#E8F5E9"/>
														<path d="M20 24H44V40H20V24Z" fill="#A5D6A7"/>
														<path d="M24 34L30 40L44 26" stroke="#388E3C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
														<circle cx="20" cy="20" r="3" fill="#4CAF50"/>
													  </svg>
												}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"") === 'In Progress'){
													<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
														<circle cx="32" cy="32" r="28" stroke="#2196F3" stroke-width="4" fill="#E3F2FD"/>
														<path d="M32 16V32L44 38" stroke="#1976D2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
													  </svg>
												}@else if (meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Scheduled') {
													<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="8" y="12" width="48" height="40" rx="6" ry="6" stroke="#FF9800" stroke-width="4" fill="#FFF3E0"/>
														<circle cx="32" cy="32" r="6" fill="#FB8C00"/>
														<line x1="32" y1="18" x2="32" y2="46" stroke="#FB8C00" stroke-width="3" stroke-linecap="round"/>
													  </svg>
												}@else if (meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Yet To Schedule') {
													<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="8" y="12" width="48" height="40" rx="6" ry="6" stroke="#9E9E9E" stroke-width="3" fill="none" stroke-dasharray="4 4"/>
														<line x1="16" y1="20" x2="48" y2="20" stroke="#9E9E9E" stroke-width="2" stroke-dasharray="2 2"/>
													  </svg>
												}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Draft Sent'){
													<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
														<!-- Card background -->
														<rect width="200" height="150" rx="16" ry="16" fill="#ECEFF1" />
														
														<!-- Pencil icon -->
														<path d="M60 110 L80 130 L140 70 L120 50 Z" fill="#607D8B" />
														<rect x="130" y="55" width="20" height="10" fill="#90A4AE" />
													  </svg>
												}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Approved') {
													<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
														<rect width="200" height="150" rx="16" ry="16" fill="#E8F5E9" />
														<path d="M70 85 L90 105 L130 65" stroke="#388E3C" stroke-width="8" fill="none" stroke-linecap="round" stroke-linejoin="round" />
													  </svg>
												}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'overDue'){
													<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
														<!-- Card background -->
														<rect width="200" height="150" rx="16" ry="16" fill="#FFEBEE" />
														
														<!-- Circle with exclamation mark -->
														<circle cx="100" cy="85" r="30" fill="#D32F2F" />
														<line x1="100" y1="65" x2="100" y2="95" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round"/>
														<circle cx="100" cy="110" r="5" fill="#FFFFFF" />
													  </svg>

												}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== "Pending") {
													<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
														<!-- Card background -->
														<rect width="200" height="150" rx="16" ry="16" fill="#FFF3E0" />
														
														<!-- Clock circle -->
														<circle cx="100" cy="85" r="30" fill="#FB8C00" />
														
														<!-- Clock hands -->
														<line x1="100" y1="85" x2="100" y2="65" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round" />
														<line x1="100" y1="85" x2="115" y2="85" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round" />
													  </svg>

												}
											</div>
											<div class="adc-cl-black">
												<div class="card-name">{{meetingStatus.get(chip.MEETINGHISSTATUS+"")}}</div>
												<div class="fw-600 font-30 adc-pt15">{{chip.MEETING_COUNT}}</div>
												<!-- <div class="fw-600 font-30 adc-pt15">100000000</div> -->
											</div>
										</div>
											
									 }
									</div>
								 }
							  }@else {
								<div class="no-data">
									<img src="../../../assets/icons/noData.svg" alt="">
								</div>
							  }
						</div>
					 }

					 @if(activemeeting === 'Other Meetings'){
						<div class="meeting-card">
							<!-- [style.background]="getBackgroundColor(meetingStatus.get(chip.MEETINGHISSTATUS+''))" -->
							@if(formatedMeetingData?.otherMeetings?.length > 0){
								@for(chip of formatedMeetingData?.otherMeetings;track chip){									
									@if(chip.MEETINGHISSTATUS != ''){
										 <div class="meeting-list" (click)="getMeetings(chip)">
											<div class="d-flex gap-2">
												<div>
													@if(meetingStatus.get(chip.MEETINGHISSTATUS+"") === 'Completed'){
														<!-- <span class="material-symbols-outlined" [ngStyle]="{'color':'#4caf50'}">check_circle</span> -->
														<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="8" y="12" width="48" height="40" rx="6" ry="6" stroke="#4CAF50" stroke-width="4" fill="#E8F5E9"/>
															<path d="M20 24H44V40H20V24Z" fill="#A5D6A7"/>
															<path d="M24 34L30 40L44 26" stroke="#388E3C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
															<circle cx="20" cy="20" r="3" fill="#4CAF50"/>
														  </svg>
													}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"") === 'In Progress'){
														<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="32" cy="32" r="28" stroke="#2196F3" stroke-width="4" fill="#E3F2FD"/>
															<path d="M32 16V32L44 38" stroke="#1976D2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
														  </svg>
													}@else if (meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Scheduled') {
														<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="8" y="12" width="48" height="40" rx="6" ry="6" stroke="#FF9800" stroke-width="4" fill="#FFF3E0"/>
															<circle cx="32" cy="32" r="6" fill="#FB8C00"/>
															<line x1="32" y1="18" x2="32" y2="46" stroke="#FB8C00" stroke-width="3" stroke-linecap="round"/>
														  </svg>
													}@else if (meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Yet To Schedule') {
														<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="8" y="12" width="48" height="40" rx="6" ry="6" stroke="#9E9E9E" stroke-width="3" fill="none" stroke-dasharray="4 4"/>
															<line x1="16" y1="20" x2="48" y2="20" stroke="#9E9E9E" stroke-width="2" stroke-dasharray="2 2"/>
														  </svg>
													}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Draft Sent'){
														<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
															<!-- Card background -->
															<rect width="200" height="150" rx="16" ry="16" fill="#ECEFF1" />
															
															<!-- Pencil icon -->
															<path d="M60 110 L80 130 L140 70 L120 50 Z" fill="#607D8B" />
															<rect x="130" y="55" width="20" height="10" fill="#90A4AE" />
														  </svg>
													}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Approved') {
														<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
															<rect width="200" height="150" rx="16" ry="16" fill="#E8F5E9" />
															<path d="M70 85 L90 105 L130 65" stroke="#388E3C" stroke-width="8" fill="none" stroke-linecap="round" stroke-linejoin="round" />
														  </svg>
													}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'overDue'){
														<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
															<!-- Card background -->
															<rect width="200" height="150" rx="16" ry="16" fill="#FFEBEE" />
															
															<!-- Circle with exclamation mark -->
															<circle cx="100" cy="85" r="30" fill="#D32F2F" />
															<line x1="100" y1="65" x2="100" y2="95" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round"/>
															<circle cx="100" cy="110" r="5" fill="#FFFFFF" />
														  </svg>
	
													}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== "Pending") {
														<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
															<!-- Card background -->
															<rect width="200" height="150" rx="16" ry="16" fill="#FFF3E0" />
															
															<!-- Clock circle -->
															<circle cx="100" cy="85" r="30" fill="#FB8C00" />
															
															<!-- Clock hands -->
															<line x1="100" y1="85" x2="100" y2="65" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round" />
															<line x1="100" y1="85" x2="115" y2="85" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round" />
														  </svg>
	
													}
												</div>
											  <div class="adc-cl-black">
												<div class="card-name">{{meetingStatus.get(chip.MEETINGHISSTATUS+"")}}</div>
												<div class="fw-600 font-30 adc-pt15">{{chip.MEETING_COUNT}}</div>
											  </div>
											</div>
										</div>
									 }
								 }
							}@else {
								<div class="no-data">
									<img src="../../../assets/icons/noData.svg" alt="">
								</div>
							}
						</div>
					 }
			</div>
		</div>

	<!-- <p>My Meetings</p> 
	<mat-chip-grid #chipGrid aria-label="Enter fruits" *ngIf="formatedMeetingData?.myMeetings?.length > 0">
	<span *ngFor="let chip of formatedMeetingData.myMeetings">
		<mat-chip-row  class="chip-option" (click)="getMeetings(chip)" *ngIf="chip.MEETINGHISSTATUS != ''">
		 {{meetingStatus.get(chip.MEETINGHISSTATUS+"")}} : {{chip.MEETING_COUNT}}
		</mat-chip-row>
	</span>
	<input [matChipInputFor]="chipGrid" type="text" [ngStyle]="{'display':'none'}">
    </mat-chip-grid>
	<div class="loading-indicator">
		<mat-progress-spinner mode="indeterminate" *ngIf="isLoading" bdColor="rgba(51,51,51,0.8)" diameter='25'
			strokeWidth='3'></mat-progress-spinner>
	</div>
	<p>Other Meetings</p>
	<mat-chip-grid #chipGrid aria-label="Enter fruits" *ngIf="formatedMeetingData?.otherMeetings?.length > 0">
	<span *ngFor="let chip of formatedMeetingData.otherMeetings">
		<mat-chip-row class="chip-option" *ngIf="chip.MEETINGHISSTATUS != ''">
            {{meetingStatus.get(chip.MEETINGHISSTATUS+"")}} : {{chip.MEETING_COUNT}}
		</mat-chip-row>
		</span>
		<input [matChipInputFor]="chipGrid" type="text" [ngStyle]="{'display':'none'}">
    </mat-chip-grid>
	<div class="loading-indicator">
		<mat-progress-spinner mode="indeterminate" *ngIf="isLoading" bdColor="rgba(51,51,51,0.8)" diameter='25'
			strokeWidth='3'></mat-progress-spinner>
	</div> -->
	<!-- <mat-chip-listbox class="mat-mdc-chip-set-stacked"
					aria-span="Item selection"> 
		<mat-chip-option *ngFor="let chip of frameworkChips"
						selected [color]="chip.color"> 
			{{chip.name}} 
		</mat-chip-option> 
	</mat-chip-listbox>  -->
</div>

<div *ngIf="type=='task'"> 
	<h3 class="title">Task Count</h3> 
	<!-- <mat-chip-listbox aria-span="Item selection" [(ngModel)]="selectedPeriod" [selectable]="this.selectedPeriod === selectedTaskFilter ? false: true"> 
		<mat-chip-option class="chip-option" *ngFor="let chip of frameworkChips"
						selected [value]="chip.name" [color]="chip.color" (click)="periodChange($event,chip.name)"> 
			{{chip.name}} 
		</mat-chip-option> 
	</mat-chip-listbox>  -->
<div class="container">
	<!-- <div class="adc-d-flex adc-align-items-center adc-gap-2 adc-flex-wrap adc-pl-5">
		<div class="font adc-d-flex">
		   <span class="material-symbols-outlined" [ngStyle]="{'color':'var(--adc-primary-theme)'}">filter_alt</span>Filter:
		</div>
			   @for (chip of frameworkChips; track $index) {
				   <span class="adc-tag-icon-right adc-d-flex adc-align-items-center" [ngStyle]="{'background-color':selectedTaskFilter === chip.name ? 'var(--adc-primary-theme)' : '','border':selectedTaskFilter === chip.name ?'0.5px solid #fff' : ''}">
					   <label class="adc-cursor-pointer {{selectedTaskFilter === chip.name ? 'adc-cl-white' : ''}}" title="{{chip.name}}"  (click)="periodChange($event,chip.name)">{{chip.name}}</label>
					   </span>
			   }
		   </div> -->

		   <!-- <div class="filter" [ngStyle]="{'width':filterOpen() ? '150px' : '','height':(containerHeight - 51)+'px'}">
			<div class="font filter-icon adc-d-flex adc-gap-2">
				<span class="material-symbols-outlined" (click)="filterOpen.set(!filterOpen())" [ngStyle]="{'color':'#fff'}">filter_alt</span>
				<span [ngStyle]="{'color':'#fff'}" *ngIf="filterOpen()">Filter</span>
			 </div>
					@if(filterOpen()){
						<ul class="filter-dropdown">
							@for (chip of frameworkChips; track $index) {

									<li class="adc-cursor-pointer" (click)="periodChange($event,chip.name)" [ngStyle]="{'background-color':selectedTaskFilter === chip.name ? '#4c60cab8' : '','color':selectedTaskFilter === chip.name ? '#fff' : ''}">{{chip.name}}</li>
							}
						</ul>
					}
					</div> -->
					<div class="filter-day">
						@for (chip of frameworkChips; track $index) {	
							<!-- <span class="adc-tag-icon-right adc-d-flex adc-align-items-center" [ngStyle]="{'background-color':selectedMeetingFilter === chip.name ? 'var(--adc-primary-theme)' : '','border':selectedMeetingFilter === chip.name ?'0.5px solid #fff' : ''}">
								<label class="adc-cursor-pointer {{selectedMeetingFilter === chip.name ? 'adc-cl-white' : ''}}" title="{{chip.name}}"  (click)="periodChange($event,chip.name)">{{chip.name}}</label>
								</span>  -->
								<button class="adc-btn adc-btn-sm adc-mr5 adc-cursor-pointer" [style.border-radius]="'unset'" [ngClass]="selectedTaskFilter === chip.name ? 'filter-day-active' :''" (click)="periodChange($event,chip.name)">{{chip.name}}</button>
					}
					</div>
	<!-- <br /> -->

	<!-- <div class="adc-tab-view adc-mt10" [ngStyle]="{'margin':0,'height':(containerHeight - 51)+'px'}" id="org2">
		<div class="adc-tab-nav adc-justify-content-between">
		  <div class="adc-d-flex">
			<div class="adc-tab-button adc-tab-bs1 font active" (click)="setActiveTab2('tab1', 'org2')" data-tab-target="tab1">
			  {{'My Meeting' | translate}}</div>
			<div class="adc-tab-button adc-tab-bs1 font"  (click)="setActiveTab2('tab2', 'org2')" data-tab-target="tab2">
			  {{"Other Meetings" | translate}}</div>
		  </div>
		</div>
	
		<div class="adc-tab-content adc-w-100">
		  <div class="adc-tab-pane overflow-auto adc-tab-ps1 active" data-tab-name="tab1">
			<div class="meeting-card">
				@for(chip of formatedTaskData?.myMeetings;track chip){
					<div class="meeting-list" [style.background]="getBackgroundColor(meetingStatus.get(chip.MEETINGHISSTATUS+''))" (click)="getMeetings(chip)">
					 @if(chip.MEETINGHISSTATUS != ''){
						 <div>{{meetingStatus.get(chip.MEETINGHISSTATUS+"")}}</div>
						 <div class="fw-600 font-30 adc-pt15">{{chip.MEETING_COUNT}}</div>
					 }
					</div>
				 }
			  </div>
		  </div>

		  <div class="adc-tab-pane overflow-auto adc-tab-ps1" data-tab-name="tab2">
			<div class="meeting-card">
				@for(chip of formatedTaskData?.otherMeetings;track chip){
					<div class="meeting-list" [style.background]="getBackgroundColor(meetingStatus.get(chip.MEETINGHISSTATUS+''))" (click)="getMeetings(chip)">
					 @if(chip.MEETINGHISSTATUS != ''){
						 <div>{{meetingStatus.get(chip.MEETINGHISSTATUS+"")}}</div>
						 <div class="fw-600 font-30 adc-pt15">{{chip.MEETING_COUNT}}</div>
					 }
					</div>
				 }
			  </div>
		  </div>
		  </div>
		  </div> -->

		  <div class="meetingtypes" [ngStyle]="{'height':(containerHeight - 140)+'px'}">
			<div class="d-flex bg-primary adc-mb15">
				@for(item of meetingTypes;track item){
					<div class="meeting-item" (click)="activeMeetingTypes(item,'task')" [style.border]="activeTask !== item ? '0.5px solid #DFe3eb' : ''" [ngClass]="activeTask === item ? 'meeting-active' : ''" >
					   {{item}}
					</div>
				}
				 </div>

				 @if(activemeeting === 'My Meetings'){
					<!-- [style.background]="getBackgroundColor(meetingStatus.get(chip.MEETINGHISSTATUS+''))" -->
					<div class="meeting-card">
							  @if(formatedTaskData?.myMeetings?.length > 0){
								@for(chip of formatedTaskData?.myMeetings;track chip){
									<div class="meeting-list"  (click)="getMeetings(chip)">
									 @if(chip.MEETINGHISSTATUS != ''){
										<div class="d-flex gap-2"> 
											<div>
												@if(meetingStatus.get(chip.MEETINGHISSTATUS+"") === 'Completed'){
													<!-- <span class="material-symbols-outlined" [ngStyle]="{'color':'#4caf50'}">check_circle</span> -->
													<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="8" y="12" width="48" height="40" rx="6" ry="6" stroke="#4CAF50" stroke-width="4" fill="#E8F5E9"/>
														<path d="M20 24H44V40H20V24Z" fill="#A5D6A7"/>
														<path d="M24 34L30 40L44 26" stroke="#388E3C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
														<circle cx="20" cy="20" r="3" fill="#4CAF50"/>
													  </svg>
												}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"") === 'In Progress'){
													<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
														<circle cx="32" cy="32" r="28" stroke="#2196F3" stroke-width="4" fill="#E3F2FD"/>
														<path d="M32 16V32L44 38" stroke="#1976D2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
													  </svg>
												}@else if (meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Scheduled') {
													<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="8" y="12" width="48" height="40" rx="6" ry="6" stroke="#FF9800" stroke-width="4" fill="#FFF3E0"/>
														<circle cx="32" cy="32" r="6" fill="#FB8C00"/>
														<line x1="32" y1="18" x2="32" y2="46" stroke="#FB8C00" stroke-width="3" stroke-linecap="round"/>
													  </svg>
												}@else if (meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Yet To Schedule') {
													<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="8" y="12" width="48" height="40" rx="6" ry="6" stroke="#9E9E9E" stroke-width="3" fill="none" stroke-dasharray="4 4"/>
														<line x1="16" y1="20" x2="48" y2="20" stroke="#9E9E9E" stroke-width="2" stroke-dasharray="2 2"/>
													  </svg>
												}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Draft Sent'){
													<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
														<!-- Card background -->
														<rect width="200" height="150" rx="16" ry="16" fill="#ECEFF1" />
														
														<!-- Pencil icon -->
														<path d="M60 110 L80 130 L140 70 L120 50 Z" fill="#607D8B" />
														<rect x="130" y="55" width="20" height="10" fill="#90A4AE" />
													  </svg>
												}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Approved') {
													<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
														<rect width="200" height="150" rx="16" ry="16" fill="#E8F5E9" />
														<path d="M70 85 L90 105 L130 65" stroke="#388E3C" stroke-width="8" fill="none" stroke-linecap="round" stroke-linejoin="round" />
													  </svg>
												}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'overDue'){
													<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
														<!-- Card background -->
														<rect width="200" height="150" rx="16" ry="16" fill="#FFEBEE" />
														
														<!-- Circle with exclamation mark -->
														<circle cx="100" cy="85" r="30" fill="#D32F2F" />
														<line x1="100" y1="65" x2="100" y2="95" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round"/>
														<circle cx="100" cy="110" r="5" fill="#FFFFFF" />
													  </svg>

												}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== "Pending") {
													<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
														<!-- Card background -->
														<rect width="200" height="150" rx="16" ry="16" fill="#FFF3E0" />
														
														<!-- Clock circle -->
														<circle cx="100" cy="85" r="30" fill="#FB8C00" />
														
														<!-- Clock hands -->
														<line x1="100" y1="85" x2="100" y2="65" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round" />
														<line x1="100" y1="85" x2="115" y2="85" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round" />
													  </svg>

												}
											</div>
											<div class="adc-cl-black">
												<div class="card-name">{{meetingStatus.get(chip.MEETINGHISSTATUS+"")}}</div>
												<div class="fw-600 font-30 adc-pt15">{{chip.MEETING_COUNT}}</div>
												<!-- <div class="fw-600 font-30 adc-pt15">100000000</div> -->
											</div>
										</div>
											
									 }
									</div>
								 }
							  }@else {
								<div class="no-data">
									<img src="../../../assets/icons/noData.svg" alt="">
								</div>
							  }
					</div>
				 }

				 @if(activemeeting === 'Other Meetings'){
					<div class="meeting-card">
						<!-- [style.background]="getBackgroundColor(meetingStatus.get(chip.MEETINGHISSTATUS+''))" -->
							@if(formatedTaskData?.otherMeetings?. length > 0){
								@for(chip of formatedTaskData?.otherMeetings;track chip){									
									<div class="meeting-list" (click)="getMeetings(chip)">
									 @if(chip.MEETINGHISSTATUS != ''){
											<div class="d-flex gap-2">
												<div>
													@if(meetingStatus.get(chip.MEETINGHISSTATUS+"") === 'Completed'){
														<!-- <span class="material-symbols-outlined" [ngStyle]="{'color':'#4caf50'}">check_circle</span> -->
														<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="8" y="12" width="48" height="40" rx="6" ry="6" stroke="#4CAF50" stroke-width="4" fill="#E8F5E9"/>
															<path d="M20 24H44V40H20V24Z" fill="#A5D6A7"/>
															<path d="M24 34L30 40L44 26" stroke="#388E3C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
															<circle cx="20" cy="20" r="3" fill="#4CAF50"/>
														  </svg>
													}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"") === 'In Progress'){
														<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="32" cy="32" r="28" stroke="#2196F3" stroke-width="4" fill="#E3F2FD"/>
															<path d="M32 16V32L44 38" stroke="#1976D2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
														  </svg>
													}@else if (meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Scheduled') {
														<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="8" y="12" width="48" height="40" rx="6" ry="6" stroke="#FF9800" stroke-width="4" fill="#FFF3E0"/>
															<circle cx="32" cy="32" r="6" fill="#FB8C00"/>
															<line x1="32" y1="18" x2="32" y2="46" stroke="#FB8C00" stroke-width="3" stroke-linecap="round"/>
														  </svg>
													}@else if (meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Yet To Schedule') {
														<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="8" y="12" width="48" height="40" rx="6" ry="6" stroke="#9E9E9E" stroke-width="3" fill="none" stroke-dasharray="4 4"/>
															<line x1="16" y1="20" x2="48" y2="20" stroke="#9E9E9E" stroke-width="2" stroke-dasharray="2 2"/>
														  </svg>
													}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Draft Sent'){
														<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
															<!-- Card background -->
															<rect width="200" height="150" rx="16" ry="16" fill="#ECEFF1" />
															
															<!-- Pencil icon -->
															<path d="M60 110 L80 130 L140 70 L120 50 Z" fill="#607D8B" />
															<rect x="130" y="55" width="20" height="10" fill="#90A4AE" />
														  </svg>
													}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'Approved') {
														<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
															<rect width="200" height="150" rx="16" ry="16" fill="#E8F5E9" />
															<path d="M70 85 L90 105 L130 65" stroke="#388E3C" stroke-width="8" fill="none" stroke-linecap="round" stroke-linejoin="round" />
														  </svg>
													}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== 'overDue'){
														<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
															<!-- Card background -->
															<rect width="200" height="150" rx="16" ry="16" fill="#FFEBEE" />
															
															<!-- Circle with exclamation mark -->
															<circle cx="100" cy="85" r="30" fill="#D32F2F" />
															<line x1="100" y1="65" x2="100" y2="95" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round"/>
															<circle cx="100" cy="110" r="5" fill="#FFFFFF" />
														  </svg>
	
													}@else if(meetingStatus.get(chip.MEETINGHISSTATUS+"")=== "Pending") {
														<svg width="200" height="150" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
															<!-- Card background -->
															<rect width="200" height="150" rx="16" ry="16" fill="#FFF3E0" />
															
															<!-- Clock circle -->
															<circle cx="100" cy="85" r="30" fill="#FB8C00" />
															
															<!-- Clock hands -->
															<line x1="100" y1="85" x2="100" y2="65" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round" />
															<line x1="100" y1="85" x2="115" y2="85" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round" />
														  </svg>
	
													}
												</div>
											  <div class="adc-cl-black">
												<div class="card-name">{{meetingStatus.get(chip.MEETINGHISSTATUS+"")}}</div>
												<div class="fw-600 font-30 adc-pt15">{{chip.MEETING_COUNT}}</div>
											  </div>
											</div>
									 }
									</div>
								 }
							}@else {
								<div class="no-data">
									<img src="../../../assets/icons/noData.svg" alt="">
								</div>
							}
					</div>
				 }
		</div>

		
</div>
	<!-- <p>My Tasks</p> 
	<mat-chip-grid #chipGrid  *ngIf="formatedTaskData?.myMeetings?.length > 0">
		<mat-chip-row class="chip-option" *ngFor="let chip of formatedTaskData.myMeetings" (click)="getMeetings(chip)">
		    {{chip.TASK_STATUS}} : {{chip.TASK_COUNT}}
		</mat-chip-row>
		<input [matChipInputFor]="chipGrid" type="text" [ngStyle]="{'display':'none'}">
    </mat-chip-grid>
	<div class="loading-indicator">
		<mat-progress-spinner mode="indeterminate" *ngIf="isLoading" bdColor="rgba(51,51,51,0.8)" diameter='25'
			strokeWidth='3'></mat-progress-spinner>
	</div>
	<p>Other Meetings</p>
	<mat-chip-grid #chipGrid  *ngIf="formatedTaskData?.otherMeetings?.length > 0">
		<mat-chip-row class="chip-option" *ngFor="let chip of formatedTaskData.otherMeetings" (click)="getMeetings(chip)">
             {{chip.TASK_STATUS}} : {{chip.TASK_COUNT}}
		</mat-chip-row>
		<input [matChipInputFor]="chipGrid" type="text" [ngStyle]="{'display':'none'}">
    </mat-chip-grid>
	<div class="loading-indicator">
		<mat-progress-spinner mode="indeterminate" *ngIf="isLoading" bdColor="rgba(51,51,51,0.8)" diameter='25'
			strokeWidth='3'></mat-progress-spinner>
	</div> -->
</div>

